import { createStore } from 'vuex';
import createPlugin from 'logrocket-vuex';
import modules from './modules';
import LogRocket from '@/plugins/log-rocket';

const plugins = [];

if (LogRocket) {
    const logrocketPlugin = createPlugin(LogRocket);

    plugins.push(logrocketPlugin);
}

const state = () => ({
    loading: false,
    menuShowing: false,
});

export const getters = {
    loading: state => state.loading,
    menuShowing: state => state.menuShowing,
};

export const mutations = {
    SET_LOADING(state, value) {
        state.loading = value;
    },

    SET_MENU_SHOWING(state, value) {
        state.menuShowing = value;
    }
};

export const actions = {
    setLoading({ commit }, value) {
        commit('SET_LOADING', value);
    },

    setMenuShowing({ commit }, value) {
        commit('SET_MENU_SHOWING', value);
    }
};

const store = createStore({
    state,
    getters,
    actions,
    mutations,
    modules,
    plugins
});

export default store;
